import type { BankDispensaryMetadata } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { DispensariesApi } from 'api/DispensariesApi';
import { DISPENSARY_METADATA_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries';

export function useDispensaryMetadata(dispensaryId: string) {
  const dispensaryApi = new DispensariesApi();
  const { userBankId } = useUser();

  const {
    data: dispensaryMetadata,
    isLoading: isLoadingDispensaryMetadata,
    isError: isLoadingDispensaryMetadataError
  } = useQuery<BankDispensaryMetadata | undefined>({
    enabled: !!dispensaryId.length,
    queryKey: [DISPENSARY_METADATA_KEY, userBankId, dispensaryId],
    queryFn: () => dispensaryApi.getMetaData(userBankId, dispensaryId)
  });

  return { dispensaryMetadata, isLoadingDispensaryMetadata, isLoadingDispensaryMetadataError };
}
